import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function CommCenter(props) {
  return /* @__PURE__ */ jsxs(
    SvgIcon,
    {
      "data-testid": "CommCenter",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "CommCenter",
      "data-tidal-icon-meta": "miscellaneous",
      viewBox: "0 0 33 32",
      children: [
        /* @__PURE__ */ jsx("path", { d: "M24.585 15.2391C25.6943 15.2391 26.585 14.3484 26.585 13.2953C26.585 12.2422 25.6943 11.3516 24.585 11.3516C23.4756 11.3516 22.585 12.2422 22.585 13.2953C22.585 14.3484 23.4225 15.2391 24.585 15.2391ZM16.585 15.2391C17.6943 15.2391 18.585 14.3484 18.585 13.2953C18.585 12.2422 17.6943 11.3516 16.585 11.3516C15.4756 11.3516 14.585 12.2422 14.585 13.2953C14.585 14.3484 15.4225 15.2391 16.585 15.2391ZM8.58496 15.2391C9.69434 15.2391 10.585 14.3484 10.585 13.2953C10.585 12.2422 9.69434 11.3516 8.58496 11.3516C7.47559 11.3516 6.58496 12.2422 6.58496 13.2953C6.58496 14.3484 7.42246 15.2391 8.58496 15.2391Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M4.58496 0.29541H28.585C30.7881 0.29541 32.585 2.09229 32.585 4.23916V22.1829C32.585 24.386 30.7881 26.1267 28.585 26.1267H22.585V31.3204C22.585 31.9297 21.8818 32.286 21.39 31.9267L13.5837 26.0704H4.58371C2.38059 26.0704 0.58371 24.2735 0.58371 22.1267V4.23916C0.584961 2.09229 2.32871 0.29541 4.58496 0.29541ZM24.585 15.2392C25.6943 15.2392 26.585 14.3485 26.585 13.2954C26.585 12.2423 25.6943 11.3517 24.585 11.3517C23.4756 11.3517 22.585 12.2423 22.585 13.2954C22.585 14.3485 23.4225 15.2392 24.585 15.2392ZM16.585 15.2392C17.6943 15.2392 18.585 14.3485 18.585 13.2954C18.585 12.2423 17.6943 11.3517 16.585 11.3517C15.4756 11.3517 14.585 12.2423 14.585 13.2954C14.585 14.3485 15.4225 15.2392 16.585 15.2392ZM8.58496 15.2392C9.69434 15.2392 10.585 14.3485 10.585 13.2954C10.585 12.2423 9.69434 11.3517 8.58496 11.3517C7.47559 11.3517 6.58496 12.2423 6.58496 13.2954C6.58496 14.3485 7.42246 15.2392 8.58496 15.2392Z",
            opacity: "0.4"
          }
        )
      ]
    }
  );
}
CommCenter.tidalIconMeta = {
  categories: "miscellaneous,services,common",
  name: "CommCenter"
};
validateTidalLicense();
export {
  CommCenter
};
//# sourceMappingURL=CommCenter.js.map
